import React from 'react';
import DatagridContext from './DatagridContext';
var DatagridContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    return (React.createElement(DatagridContext.Provider, { value: value }, children));
};
export default DatagridContextProvider;
//# sourceMappingURL=DatagridContextProvider.js.map